import React, { CSSProperties } from 'react';
import { classNames } from '../../utils/classNames';
import getViewType, { FileType, ViewType } from './FileType';
import { useFetchFileViewer, useFileViewer } from './FileViewer';

export default function FileViewTrigger(props: {
    type: FileType,
    name: string
    contents: string
    children?: JSX.Element | JSX.Element[] | string
    className?: string
}) {

    const viewType = getViewType(props.type)

    const [show, jsx] = useFileViewer();
    return (
        <div
            className={classNames("text-truncate", props.className)}
            style={{ cursor: viewType === ViewType.UNKNOW ? "normal" : "pointer", width: 'calc(98vh - 3.5rem)' }}
            onClick={() => {
                if (viewType === ViewType.UNKNOW) return;
                show(props.name, viewType, props.contents);
            }}
        >
            {props.children}
            {jsx}
        </div>
    )

}

export interface FileViewerFetchTriggerProps {
    type: FileType;
    name: string;
    fetch: () => Promise<string>;
    children?: React.ReactNode;
    className?: string;
    styled?: CSSProperties;
}


export function FileViewFetchTrigger(props: FileViewerFetchTriggerProps) {
    const viewType = getViewType(props.type)
    const [show, jsx] = useFetchFileViewer();
    return (
        <>
            <div
                className={classNames("text-truncate", props.className)}
                style={{ cursor: viewType === ViewType.UNKNOW ? "normal" : "pointer", ...props.styled,  }}
                onClick={() => {
                    if (viewType === ViewType.UNKNOW) return;
                    show(props.name, viewType, props.fetch);
                }}
                title={typeof props.children === "string" ? props.children : ""}
            >
                {typeof props.children === 'function' ? props.children(viewType !== ViewType.UNKNOW) : props.children}
            </div>
            {jsx}
        </>
    )
}

export function FileViewFetchButtonTrigger(props: {
    type: FileType,
    name: string
    fetch: () => Promise<string>
    children?: JSX.Element | JSX.Element[] | string
    className?: string
}) {
    const viewType = getViewType(props.type)
    const [show, jsx] = useFetchFileViewer();
    return (
        <>
            <button
                className={classNames("text-truncate", props.className)}
                style={{ cursor: viewType === ViewType.UNKNOW ? "normal" : "pointer" }}
                onClick={() => {
                    if (viewType === ViewType.UNKNOW) return;
                    show(props.name, viewType, props.fetch);
                }}
            >
                {props.children}
            </button>
            {jsx}
        </>
    )
}